/**
 * actions.ts
 * ----------------
 * Action name definitions.
 */

/**
 * Admin portal: request creation of one or more status pushes.
 */
export const Admin_RequestCreateStatusPushes = 'Admin_RequestCreateStatusPushes';

/**
 * Admin portal: receive response of one successful status push creation.
 */
export const Admin_ReceiveCreatedStatusPush = 'Admin_ReceiveCreatedStatusPush';

/**
 * Admin portal: receive response of multiple successful status push creation.
 */
export const Admin_ReceiveCreatedStatusPushes = 'Admin_ReceiveCreatedStatusPushes';

/**
 * Admin Portal: receive response of one successful live site event creation.
 */
export const UpdatePortal_ReceiveCreatedLiveSiteEvent = 'UpdatePortal_ReceiveCreatedLiveSiteEvent';

/**
 * Shared: preload error.
 */
export const PreloadError = 'PreloadError';

/**
 * Shared: preload pending approvals.
 */
export const PreloadPendingApprovals = 'PreloadPendingApprovals';

/**
 * Shared: preload recent updates.
 */
export const PreloadRecentUpdates = 'PreloadRecentUpdates';

/**
 * Shared: preload services.
 */
export const PreloadServices = 'PreloadServices';

/**
 * Shared: preload statuses.
 */
export const PreloadStatuses = 'PreloadStatuses';

/**
 * Preload active live site events
 */
export const PreloadActiveLiveSiteEvents = 'PreloadActiveLiveSiteEvents';

/**
 * Preload live site event.
 */
export const PreloadLiveSiteEvent = 'PreloadLiveSiteEvent';

/**
 * Preload resolved live site events
 */
export const PreloadResolvedLiveSiteEvents = 'PreloadResolvedLiveSiteEvents';

/**
 * Update Portal: request creation of one live site event
 */
export const UpdatePortal_RequestCreateLiveSiteEvent = 'UpdatePortal_RequestCreateLiveSiteEvent';

/**
 * Update Portal: request update of one live site event
 */
export const UpdatePortal_RequestUpdateLiveSiteEvent = 'UpdatePortal_RequestUpdateLiveSiteEvent';

/**
 * Update Portal: request to mitigate one live site event
 */
export const UpdatePortal_RequestMitigateLiveSiteEvent = 'UpdatePortal_RequestMitigateLiveSiteEvent';

/**
 * Update Portal: request to resolve one live site event
 */
export const UpdatePortal_RequestResolveLiveSiteEvent = 'UpdatePortal_RequestResolveLiveSiteEvent';

/**
 * Update Portal: request to send comment on one live site event
 */
export const UpdatePortal_RequestCommentLiveSiteEvent = 'UpdatePortal_RequestCommentLiveSiteEvent';

/**
 * Update Portal: approve an outstanding approval.
 */
export const UpdatePortal_ApprovePendingApproval = 'UpdatePortal_ApprovePendingApproval';

/**
 * Update Portal: edit and approve an outstanding approval.
 */
export const UpdatePortal_EditAndApprovePendingApproval = 'UpdatePortal_EditAndApprovePendingApproval';

/**
 * Update Portal: reject an outstanding approval.
 */
export const UpdatePortal_RejectPendingApproval = 'UpdatePortal_RejectPendingApproval';

/**
 * Update Portal: refresh pending approvals.
 */
export const UpdatePortal_GetPendingApprovals = 'UpdatePortal_GetPendingApprovals';

/**
 * Update Portal: update the current list of pending approvals with newly received data.
 */
export const UpdatePortal_ReceivePendingApprovals = 'UpdatePortal_ReceivePendingApprovals';

/**
 * Update Portal: get an GitHub incident.
 */
export const UpdatePortal_GetGitHubIncident = 'UpdatePortal_GetGitHubIncident';

/**
 * Update Portal: get an GitHub incident for a pending approval edit.
 */
export const UpdatePortal_GetGitHubIncidentForPending = 'UpdatePortal_GetGitHubIncidentForPending';

/**
 * Update Portal: load GitHub incident data into application state.
 */
export const UpdatePortal_ReceiveGitHubIncident = 'UpdatePortal_ReceiveGitHubIncident';

/**
 * Update Portal: load GitHub incident data into application state for a pending approval edit.
 */
export const UpdatePortal_ReceiveGitHubIncidentForPending = 'UpdatePortal_ReceiveGitHubIncidentForPending';

/**
 * Update Portal: get an incident.
 */
export const UpdatePortal_GetIncident = 'UpdatePortal_GetIncident';

/**
 * Update Portal: get an incident for a pending approval edit.
 */
export const UpdatePortal_GetIncidentForPending = 'UpdatePortal_GetIncidentForPending';

/**
 * Update Portal: load incident data into application state.
 */
export const UpdatePortal_ReceiveIncident = 'UpdatePortal_ReceiveIncident';

/**
 * Update Portal: load incident data into application state for a pending approval edit.
 */
export const UpdatePortal_ReceiveIncidentForPending = 'UpdatePortal_ReceiveIncidentForPending';

/**
 * Update Portal: for pending create action, initialize the related state to be valid.
 */
export const UpdatePortal_ConfigureIncidentForPending = 'UpdatePortal_ConfigureIncidentForPending';

/**
 * Update Portal: clear incident state.
 */
export const UpdatePortal_ClearIncident = 'UpdatePortal_ClearIncident';

/**
 * Update Portal: clear incident state for pending approval edit.
 */
export const UpdatePortal_ClearIncidentForPending = 'UpdatePortal_ClearIncidentForPending';

/**
 * Shared: acknowledge that error has been seen
 */
export const Shared_AcknowledgeError = 'Shared_AcknowledgeError';

/**
 * Shared: acknowledge that success dialog has been seen
 */
export const Shared_AcknowledgeSuccess = 'Shared_AcknowledgeSuccess';

/**
 * Shared: clear context for portal's history section.
 */
export const Shared_ClearHistoryViewContext = 'Shared_ClearHistoryViewContext';

/**
 * Shared: clear context for portal's event section.
 */
export const Shared_ClearLiveSiteEventViewContext = 'Shared_ClearLiveSiteEventViewContext';

/**
 * Shared: receive data from request to get active live site events.
 */
export const Shared_ReceiveGetActiveLiveSiteEvents = 'Shared_ReceiveGetActiveLiveSiteEvents';

/**
 * Shared: receive data from request to get a live site event.
 */
export const Shared_ReceiveGetLiveSiteEvent = 'Shared_ReceiveGetLiveSiteEvent';

/**
 * Shared: receive data from request to get resolved live site events.
 */
export const Shared_ReceiveGetResolvedLiveSiteEvents = 'Shared_ReceiveGetResolvedLiveSiteEvents';

/**
 * Shared: update the current status with newly received data.
 */
export const Shared_ReceiveGetStatus = 'Shared_ReceiveGetStatus';

/**
 * Shared: request the current set of active live site events.
 */
export const Shared_RequestGetActiveLiveSiteEvents = 'Shared_RequestGetActiveLiveSiteEvents';

/**
 * Shared: request a live site event.
 */
export const Shared_RequestGetLiveSiteEvent = 'Shared_RequestGetLiveSiteEvent';

/**
 * Shared: request the current set of resolved live site events.
 */
export const Shared_RequestGetResolvedLiveSiteEvents = 'Shared_RequestGetResolvedLiveSiteEvents';

/**
 * Shared: get the status.
 */
export const Shared_RequestGetStatus = 'Shared_RequestGetStatus';

/**
 * Shared: set context for portal's history section.
 */
export const Shared_SetHistoryViewContext = 'Shared_SetHistoryViewContext';

/**
 * Shared: set context for portal's event section.
 */
export const Shared_SetLiveSiteEventViewContext = 'Shared_SetLiveSiteEventViewContext';
